import React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import InfoTooltipContent from 'src/App/Dashboards/Market/Components/Tooltips/InfoTooltipContent';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff0',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(12),
    border: 'none',
  },
}));

const TooltipNew = ({
  title,
  content,
  children,
  disable,
  placement,
  arrow,
  enterTouchDelay,
  leaveTouchDelay,
}: {
  title?: string | JSX.Element;
  content: JSX.Element | string;
  children: JSX.Element;
  disable?: boolean;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  arrow?: boolean;
  enterTouchDelay?: number;
  leaveTouchDelay?: number;
}) => {
  if (disable) {
    return children;
  }

  return (
    <CustomTooltip
      PopperProps={{
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              rootBoundary: 'viewport',
            },
          },
        ],
      }}
      placement={placement}
      arrow={arrow}
      enterTouchDelay={enterTouchDelay ? enterTouchDelay : 0}
      leaveTouchDelay={leaveTouchDelay ? leaveTouchDelay : 5000}
      title={<InfoTooltipContent title={title} content={content} />}
    >
      {children}
    </CustomTooltip>
  );
};

export default TooltipNew;
